export enum EPetFeeMethod {
  FLAT = 'FLAT',
  BY_PETS_COUNT = 'BY_PETS_COUNT',
  BY_PET_SPECIES = 'BY_PET_SPECIES',
}

export type TPriceValue = {
  value: number | null;
  min: number | null;
  max: number | null;
};

export type TSpeciesRate = {
  specieName: string;
  price: TPriceValue;
};

export type TBySpeciesRates = {
  entries: TSpeciesRate[];
};

export type TByPetCountRates = {
  firstPetPrice: TPriceValue;
  secondPetPrice: TPriceValue;
  eachAdditionalPetPrice: TPriceValue;
};

export type TCustomPetFee = {
  method: EPetFeeMethod;
  flatRate: number | null;
  bySpeciesRates: TBySpeciesRates | null;
  byPetCountRates: TByPetCountRates | null;
};

export type TPriceSection<T> = {
  label: string;
  key: keyof T;
};

export const COUNT_SECTIONS: TPriceSection<TByPetCountRates>[] = [
  { label: '1st Pet', key: 'firstPetPrice' },
  { label: '2nd Pet', key: 'secondPetPrice' },
  { label: 'Each Additional Pet', key: 'eachAdditionalPetPrice' },
];

export const SECTIONS_BY_METHOD: {
  [EPetFeeMethod.BY_PETS_COUNT]: TPriceSection<TByPetCountRates>[];
} = {
  [EPetFeeMethod.BY_PETS_COUNT]: COUNT_SECTIONS,
};
